import { track } from '@bnnvara/analytics/src/track';
import { BaseButton } from '@bnnvara/buttons';
import { Chevron } from '@bnnvara/icons/src/components/UserInterfaceIcons/Chevron';
import React from 'react';

import * as S from './styled';

const OnboardingInformationLink = () => (
  <S.Wrapper>
    <BaseButton
      size="large"
      type="link"
      variant="underline"
      href="/wijzijnvoor-jijook"
      onClick={() => track('profiel', 'click', 'wijzijnvoor-jijook')}
    >
      Meer over BNNVARA
      <Chevron />
    </BaseButton>
  </S.Wrapper>
);

export default OnboardingInformationLink;
